import React from 'react'
import { Card, Col, Row, Form, Button, Badge, Dropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom'
import LoadingModal from "../../../components/modal/LoadingModal";
import SimpleModal from "../../../components/modal/SimpleModal";

import { isNullOrUndefined } from 'util';
import { getUser, createUser, updateUser} from '../../../resources/API';
import { toCapitalize, booleanToYesNo, yesNoToBoolean } from '../../../resources/Utils';
import Authorization from './components/Authorization';
import Profile from '../components/Profile';

export default class DebitUser extends React.Component {

  constructor(props) {
    super(props)
    var actionAllow = ['view', 'create', 'update'];
    if (!actionAllow.includes(props.match.params.action)){
        props.history.push("/notFound");
    }
    this.state = {
      modal :{
        header : null,
        body : null,
        footer : null,
        show : false,
        variant : 'danger'
      },
      account: false,
      action: props.match.params.action,
      userInfo : {
        userId : '',
        merchantId : props.merchantProfile.merchantId,
        merchantName : props.merchantProfile.merchantName,
        fullName : '',
        username : '',
        email : '',
        contactNumber : '',
        note: '',
        status: ''
      },
      viewChange :null,
      modalViewChangeShow: false,
      userResponse: null,
      authorizationInfo : {
        account : {
          value : false,
          overview : false,
          profile : false,
          user : false,
          customer : false
        },
        report : {
          value : false,
          transaction : false,
          schdTransaction : false,
          registration : false,
          regisMonitor : false,
          statusSummary : false
        }
      },
      loadingShow : false,
    }
  }

  handleUserAuthChange = (group, name, value) => {
    if (this.state.authorizationInfo){
      let currentState = this.state.authorizationInfo;
      currentState[group][name] = value;
      if(name === "value") {
        Object.entries(currentState[group]).forEach(([key]) => {
          if(key !== "value") currentState[group][key] = value;
        });
      }
      this.setState({
        authorizationInfo : currentState
      });
    }
  }
  
  handleUserInfoChange = (event) => {
    if (this.state.userInfo){
      const { name, value } = event.target;
      var currentState = this.state.userInfo;
      currentState[name] = value;
      this.setState({
        userInfo : currentState
      });
    }
  }

  handleSubmitUser =  (e) => {   
    e.preventDefault();
    this.userProfileAction(this.state.action);
  }

  handleDeleteUser = () => {
    const footer = <React.Fragment>
                      <Button 
                        variant="scb" 
                        onClick={() => 
                          {
                            this.handleModalClose();
                            this.userProfileAction("delete");
                          }
                        }>Confirm</Button>
                      <Button variant="outline-secondary" onClick={this.handleModalClose}>Cancel</Button>
                  </React.Fragment>
    this.setState({
      modal : {
      header : "Delete user",
      body : "Are you sure to delete this user?",
      footer : footer,
      show : true,
      variant : "scb",
      backdrop : 'static'
      }
    });
  }

  userProfileAction = async (action, status=null) => {
    this.setState({loadingShow : true});
    const {userInfo, authorizationInfo} = this.state;
    const {accessToken} = this.props.location.state;
    const capAction = toCapitalize(status ? status.description : action);
    const userProfile = {
      userId : userInfo.userId,
      merchantId : userInfo.merchantId,
      merchantName : userInfo.merchantName,
      fullName: userInfo.fullName,
      username: userInfo.username,
      email: userInfo.email,
      contactNumber: userInfo.contactNumber,
      note: userInfo.note,
      status: status ? status.code : userInfo.status,
      userAuthorize : {
        account : {
          profile : booleanToYesNo(authorizationInfo.account.profile),
          user : booleanToYesNo(false),
          customerProfile : booleanToYesNo(authorizationInfo.account.customer)
        },
	      report : {
          transactionReport: booleanToYesNo(authorizationInfo.report.transaction),
          transactionRecurringReport: booleanToYesNo(false),
          registrationReport: booleanToYesNo(authorizationInfo.report.registration),
          onlineRegistrationReport: booleanToYesNo(authorizationInfo.report.regisMonitor),
          summaryPaymentTransactionByStatus: booleanToYesNo(false)
        }
      }
    };
    let userResponse;
    if(action === 'create'){
      userResponse = await createUser(userProfile, accessToken);
    } else {
      userResponse = await updateUser(action.toUpperCase(), userProfile, accessToken);
    }

    this.setState({loadingShow : false});
    const footer = <LinkContainer to="/user" activeClassName="">
                      <Button variant="outline-secondary">Back to User List</Button>
                  </LinkContainer>
    if (userResponse.status === 200){
      this.setState({
        modal : {
          header : "Success",
          body : capAction + " user successful",
          footer : footer,
          show : true,
          variant : "success",
          backdrop : 'static'
        }
      });
    } else {
      this.setState({
        modal : {
        header : capAction + " user error",
        body : userResponse.body.validationMessages[0].description,
        show : true,
        variant : "danger"
        }
      });
    }
  }


  handleModalClose = () => {
    let modal = this.state.modal;
    modal.show = false;
    this.setState({
      modal: modal
    });
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.match.params.action !== nextProps.match.params.action) {
        this.setState ({
            action: nextProps.match.params.action,
        });
        this.getData(nextProps.match.params.action);
    }
  }

  componentDidMount(){
    this.getData(this.state.action);
  }

  getData = async (action) => {
    this.setState({loadingShow : true});
    const {userId} = this.props.match.params;
    const {merchantId} = this.state.userInfo;
    if (action === 'view' || action === 'update'){
      const userResponse = await getUser(merchantId, userId);
      if (userResponse.status !== 200 ) {
        window.location = '/notfound';
      }

      const userProfile = userResponse.body.getResponse;
      this.setState({
        userInfo : {
          userId : userProfile.userId,
          merchantId : userProfile.merchantId,
          merchantName : userProfile.merchantName,
          fullName : userProfile.fullName,
          username : userProfile.username,
          email : userProfile.email,
          contactNumber : userProfile.contactNumber,
          note: userProfile.note,
          status : userProfile.status
        },
        authorizationInfo : {
          account : {
            value : yesNoToBoolean(userProfile.authorize.account.profile) ||
                    yesNoToBoolean(userProfile.authorize.account.user) ||
                    yesNoToBoolean(userProfile.authorize.account.customerProfile),
            profile : yesNoToBoolean(userProfile.authorize.account.profile),
            user : yesNoToBoolean(userProfile.authorize.account.user),
            customer :yesNoToBoolean(userProfile.authorize.account.customerProfile)
          },
          report : {
            value : yesNoToBoolean(userProfile.authorize.report.transactionReport) ||
                    yesNoToBoolean(userProfile.authorize.report.transactionRecurringReport) ||
                    yesNoToBoolean(userProfile.authorize.report.registrationReport) ||
                    yesNoToBoolean(userProfile.authorize.report.onlineRegistrationReport) ||
                    yesNoToBoolean(userProfile.authorize.report.summaryPaymentTransactionByStatus),
            transaction : yesNoToBoolean(userProfile.authorize.report.transactionReport),
            schdTransaction : yesNoToBoolean(userProfile.authorize.report.transactionRecurringReport),
            registration : yesNoToBoolean(userProfile.authorize.report.registrationReport),
            regisMonitor : yesNoToBoolean(userProfile.authorize.report.onlineRegistrationReport),
            statusSummary : yesNoToBoolean(userProfile.authorize.report.summaryPaymentTransactionByStatus)
          }

        }
      });
    }
    this.setState({loadingShow : false});
  }

  getTextWithAction(action){
    if (action === 'create'){
      return 'created';
    } else {
      return 'updated';
    }
  }

  render() {
    const {role, accessToken, username} = this.props;
    const { action, userInfo, authorizationInfo, loadingShow, modal } = this.state;
    const {filterCriteria} = this.props.location.state;
    if (!['create', 'update', 'view'].includes(action)){
      window.location = '/notfound';
    }
    if (!role.includes("DD_ACCOUNT_USER")) {
      window.location = '/unauthorized';
    }
    
    const isMerchantNotFound = (isNullOrUndefined(userInfo.merchantName) || userInfo.merchantName === '');
    const disableField = isMerchantNotFound || (action === 'view');
    

    return (
      <React.Fragment>
        
        <Row className="mx-auto card-width-1200 mt-4">
            <Col sm={{span:2, offset:10}} className="p-0 text-right">
            <Dropdown alignRight>
                <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic"> 
                <span> Action</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {userInfo.status === 'A' &&
                    <Dropdown.Item
                        as={Link}
                        to={{
                            pathname:"/user/update/" + userInfo.merchantId + '/' + userInfo.userId,
                            state:{
                            role:role,
                            accessToken: accessToken,
                            username:username,
                            filterCriteria:filterCriteria
                            }
                            }}
                    >
                        Edit
                    </Dropdown.Item>
                    }
                    {userInfo.status === 'A' &&
                    <Dropdown.Item variant="link" onClick={()=>this.userProfileAction("update", {code :"L", description: "Lock"})} >Lock</Dropdown.Item>
                    }
                    {userInfo.status === 'L' &&
                    <Dropdown.Item variant="link" onClick={()=>this.userProfileAction("update", {code :"A", description: "Unlock"})} >Unlock</Dropdown.Item>
                    }
                    <Dropdown.Item variant="link" onClick={this.handleDeleteUser} >Delete</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            </Col>
        </Row>
        <Form id="userActionForm" onSubmit={this.handleSubmitUser}>
            <Card className="shadow mx-auto mt-4 card-width-1200 pb-4">
            <Card.Header className="bg-white font-weight-bold text-scb">
                {toCapitalize(action)} User
            </Card.Header>
            <Card.Body>
                <Row>
                <Col sm={6} className="border-right">
                    <Profile 
                        userInfo = {userInfo}
                        disabled={disableField}
                        onChange={this.handleUserInfoChange}
                        action={action}
                        onClickFindMerchant={this.handleFindMerchant}
                    />
                </Col>
                <Col sm={6}>
                    <Authorization 
                        authorizationInfo = {authorizationInfo}
                        disabled={disableField}
                        onChange={this.handleUserAuthChange}
                    />
                </Col>
                </Row>
            </Card.Body>
            </Card>
            <Row className="mx-auto card-width-1200 mt-5 mb-5">
            { (action !== 'update') ?
                <Col sm={3} className="p-0">
                    <LinkContainer 
                    to={{
                        pathname : "/user",
                        state:{
                            filterCriteria:filterCriteria
                            }
                        }
                        } activeClassName="">
                        <Button variant="outline-secondary" block>Back to User List</Button>
                    </LinkContainer>
                </Col>
                :
                <Col sm={3} className="p-0">
                    <LinkContainer
                        to={{
                            pathname:"/user/view/" + userInfo.merchantId + '/' + userInfo.userId,
                            state:{
                            role:role,
                            accessToken: accessToken,
                            username:username,
                            filterCriteria: filterCriteria,
                            }
                        }}
                        activeClassName="">
                        <Button variant="outline-secondary" block>Discard Edit</Button>
                    </LinkContainer>
                </Col>
            }
            {
                action === 'create' ?
                <Col sm={{ span: 3, offset: 6 }} className="p-0">
                <Button type="submit" variant="scb" disabled={isMerchantNotFound} block>Create User</Button>
                </Col>
                : action === 'update' ?
                <Col sm={{ span: 3, offset: 6 }} className="p-0">
                <Button type="submit" variant="scb" disabled={isMerchantNotFound} block>Update User</Button>
                </Col>
                :
                <></>
            }
            
            </Row>
        </Form>
        <LoadingModal show={loadingShow} />
        <SimpleModal
          modal={modal}
          onClose={this.handleModalClose}
        />  
      </React.Fragment>
    )
  }
}
